import { PaymentTerminal } from '@mews-commander/data-access';

export const filterPaymentTerminals =
    (canLinkInvoicesConfig = false) =>
    (terminal: PaymentTerminal) =>
        canLinkInvoicesConfig ? !!(terminal.isStripeTerminal || terminal.isAdyenTerminal) : true;
